<div class="zwi-upload-series-card">
  <div class="zwi-column-center">
    <mat-icon class="zwi-tile__icon">add</mat-icon>
    <div class="mat-headline-5">Upload Series</div>
  </div>
</div>
